export enum StatusGroupIdsEnum {
  QUOTED = 0,
  ORDERED = 1,
  PICKED = 2,
  SHIPPED = 3,
  INVOICED = 4,
  PAID_IN_FULL = 5,
  CANCELED = 9,
  HOVER = 40,
}
